function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#ffcab2}.cls-4{fill:#4d4d4f}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_537",
  fill: "#fff",
  d: "M6 0h38a6 6 0 0 1 6 6v38a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "power-plant",
  transform: "translate(7 7)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1125",
  d: "M8.488-3.975A1.12 1.12 0 0 0 7.366-5h-3.75A1.117 1.117 0 0 0 2.5-3.975L1.021 19.956a1.1 1.1 0 0 0 .393.932 1.138 1.138 0 0 0 .729.264l.267-.031 6.576-1.582a1.113 1.113 0 0 0 .855-1.164z",
  className: "cls-2",
  transform: "translate(.509 6)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1126",
  fill: "#f26524",
  d: "M13.83 11.746a1.133 1.133 0 0 0-.945-.219L2.064 13.864A2.614 2.614 0 0 0 0 16.4v5.47a2.612 2.612 0 0 0 2.625 2.593h10.5a1.119 1.119 0 0 0 1.125-1.111V12.611a1.1 1.1 0 0 0-.42-.865z",
  transform: "translate(0 11.537)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1127",
  d: "M6.875 17.972h-3a1.111 1.111 0 1 1 0-2.222h3a1.111 1.111 0 1 1 0 2.222z",
  className: "cls-2",
  transform: "translate(1.375 13.583)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1128",
  d: "M8.875 2.222h-6.75A1.119 1.119 0 0 1 1 1.111 1.119 1.119 0 0 1 2.125 0h6.75A1.119 1.119 0 0 1 10 1.111a1.119 1.119 0 0 1-1.125 1.111z",
  className: "cls-4",
  transform: "translate(.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1129",
  d: "M31.1 10.718L9.353 6.274a1.132 1.132 0 0 0-.937.227 1.1 1.1 0 0 0-.416.86V25.88a1.119 1.119 0 0 0 1.125 1.111h20.25A2.612 2.612 0 0 0 32 24.4V11.805a1.114 1.114 0 0 0-.9-1.087z",
  className: "cls-2",
  transform: "translate(4 9.009)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2733",
  transform: "translate(16.5 22.667)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1134",
  d: "M12.875 14.213h-.75A1.119 1.119 0 0 1 11 13.1v-.741a1.119 1.119 0 0 1 1.125-1.111h.75A1.119 1.119 0 0 1 14 12.361v.739a1.119 1.119 0 0 1-1.125 1.113z",
  className: "cls-4",
  transform: "translate(-11 -11.25)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1135",
  d: "M16.875 14.213h-.75A1.119 1.119 0 0 1 15 13.1v-.741a1.119 1.119 0 0 1 1.125-1.111h.75A1.119 1.119 0 0 1 18 12.361v.739a1.119 1.119 0 0 1-1.125 1.113z",
  className: "cls-4",
  transform: "translate(-9 -11.25)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1136",
  d: "M20.875 14.213h-.75A1.119 1.119 0 0 1 19 13.1v-.741a1.119 1.119 0 0 1 1.125-1.111h.75A1.119 1.119 0 0 1 22 12.361v.739a1.119 1.119 0 0 1-1.125 1.113z",
  className: "cls-4",
  transform: "translate(-7 -11.25)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1137",
  d: "M12.875 18.213h-.75A1.119 1.119 0 0 1 11 17.1v-.741a1.119 1.119 0 0 1 1.125-1.111h.75A1.119 1.119 0 0 1 14 16.361v.739a1.119 1.119 0 0 1-1.125 1.113z",
  className: "cls-4",
  transform: "translate(-11 -9.324)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1138",
  d: "M16.875 18.213h-.75A1.119 1.119 0 0 1 15 17.1v-.741a1.119 1.119 0 0 1 1.125-1.111h.75A1.119 1.119 0 0 1 18 16.361v.739a1.119 1.119 0 0 1-1.125 1.113z",
  className: "cls-4",
  transform: "translate(-9 -9.324)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1139",
  d: "M20.875 18.213h-.75A1.119 1.119 0 0 1 19 17.1v-.741a1.119 1.119 0 0 1 1.125-1.111h.75A1.119 1.119 0 0 1 22 16.361v.739a1.119 1.119 0 0 1-1.125 1.113z",
  className: "cls-4",
  transform: "translate(-7 -9.324)"
})));

function SvgColorIconManufacturer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "color-icons_Manufacturers",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorIconManufacturer);
export default __webpack_public_path__ + "static/media/colorIconManufacturer.12aa2d8f.svg";
export { ForwardRef as ReactComponent };